import React from "../../__compat__/react/main.entry.mjs.mjs";
import { pickAriaProps, pickDataProps } from "../../interfaces/commonProps.mjs.mjs";
import { StyledSlider } from "./Slider.styles.mjs.mjs";
export const SliderThumb = React.forwardRef(({ disabled = false, invalid = false, list, min, max, step, value, onChange, ...restProps }, ref) => {
    return (React.createElement(StyledSlider, { disabled: disabled, invalid: invalid, list: list, max: max, min: min, onChange: onChange, ref: ref, role: "slider", step: step, value: value, ...pickDataProps(restProps), ...pickAriaProps(restProps) }));
});
SliderThumb.displayName = 'SliderThumb';
//# sourceMappingURL=SliderThumb.mjs.mjs.map